import MinutesToText from '@/components/ezuro/common/MinutesToText.vue'
import moment from 'moment';

export default {
  name: 'TimeBetween',
  props: {
    dateStart: {
      type: Date | String
    },
    dateEnd: {
      type: Date | String
    }
  },
  components: {
    MinutesToText
  },
  computed: {
    minutes () {
      const duration = moment.duration(moment(this.dateEnd).diff(moment(this.dateStart)));

      return duration.asMinutes();
    }
  }
}
